import { Cookie } from '@vue-util/cookie';
import { cookies } from 'config';

const isValidZipCode = (zipCode: string) => /^\d{5}$/.test(zipCode);

function parseMISCGCsCookie(): { userName: string | null } {
  let userName: string | null = null;
  const MISCGCs = Cookie.get(cookies.miscGCs);

  if (MISCGCs) {
    const cookiesArray = MISCGCs.split('3_87_');
    cookiesArray.forEach((cookie) => {
      const cookieValue = cookie.split('1_92_')[1];
      if (cookie.includes('UserName')) {
        userName = cookieValue;
      }
    });
  }

  return { userName };
}

export const getUserIds = () => {
  // Don't change the order of the calls of Cookie.get or it will fail the test
  const userGuid = Cookie.get(cookies.userGuid);
  const userId = Cookie.get(cookies.userId);
  const { userName } = parseMISCGCsCookie();
  const secureUserToken = Cookie.get(cookies.secureUserToken);
  const isSignedIn = Cookie.get(cookies.signedIn) === '1';

  return {
    userGuid,
    userId,
    userName,
    secureUserToken,
    isSignedIn,
  };
};

export const setUserCookies = ({ guid, id }: { guid: string; id: string }) => {
  const thirthyDaysInMS = 2592000000;
  const expires = new Date(new Date().getTime() + thirthyDaysInMS);
  Cookie.set(cookies.userGuid, guid, false, { expires });
  Cookie.set(cookies.userId, id, false, { expires });
};

export const getSelectedStoreCookie = () => {
  const CSL = Cookie.get(cookies.csl);
  const bopsPickupInStore = Cookie.get(cookies.bopsPickupInStore, cookies.miscGCs);

  return CSL || bopsPickupInStore;
};

export const setSelectedStoreCookie = (locationNumber = '') => {
  Cookie.set(cookies.bopsPickupInStore, locationNumber, cookies.miscGCs);
};

export const getZipCodeCookie = () => Cookie.get(cookies.zipCode, cookies.miscGCs);

export const getBigTicketZipCookie = () => Cookie.get(cookies.bigTicketZipCode, cookies.miscGCs);

export const setZipCodeCookie = (zipCode = '') => {
  if (!isValidZipCode(zipCode)) {
    return;
  }

  Cookie.set(cookies.zipCode, zipCode, cookies.miscGCs);
};
